import { render, staticRenderFns } from "./ComparativeScoreController.vue?vue&type=template&id=9ace91ce&"
import script from "./ComparativeScoreController.vue?vue&type=script&lang=ts&"
export * from "./ComparativeScoreController.vue?vue&type=script&lang=ts&"
import style0 from "./comparative-score.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports